import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import { CloudDownload, Delete } from "@mui/icons-material";

const FileList = ({
  files = [],
  setIsDelete,
  setSelectedFile,
  selectedDate = "",
  setSelectedDate,
}) => {
  const [downloading, setDownloading] = useState(null);

  const handleDownload = async (realUrl, displayName) => {
    setDownloading(displayName);
    try {
      // 1. Ocultar la URL real (usando window.history en lugar de history directamente)
      const cleanUrl = `/download?name=${encodeURIComponent(displayName)}`;
      window.history.replaceState({}, "", cleanUrl);

      // 2. Crear enlace temporal
      const link = document.createElement("a");

      // Opción A: Si el servidor permite CORS
      const response = await fetch(realUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      link.href = blobUrl;

      link.setAttribute("download", displayName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Limpiar URL después
      setTimeout(
        () => window.history.replaceState({}, "", window.location.pathname),
        500
      );

      // Liberar objeto URL
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
      window.open(realUrl, "_blank");
    } finally {
      setDownloading(null);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  return (
    <Paper elevation={3} sx={{ marginTop: 2 }}>
      <Box p={2}>
        <Typography variant="h6" gutterBottom>
          Archivos subidos
        </Typography>

        <Box mb={2}>
          <Typography variant="subtitle1" gutterBottom>
            Seleccionar fecha:
          </Typography>
          <input
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "16px",
            }}
          />
          {selectedDate && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Fecha seleccionada: {new Date(selectedDate).toLocaleDateString()}
            </Typography>
          )}
        </Box>

        {files.length === 0 ? (
          <Typography variant="body2" color="textSecondary">
            No hay archivos disponibles
          </Typography>
        ) : (
          <List>
            {files.map((file, index) => (
              <ListItem key={index} divider>
                <ListItemText primary={file?.name} sx={{ marginRight: 8 }} />
                <ListItemSecondaryAction sx={{ display: "flex", gap: 2 }}>
                  <IconButton
                    edge="end"
                    aria-label="descargar"
                    onClick={() => handleDownload(file?.url, file?.name)}
                    sx={{ color: "#e7ef7d" }}
                  >
                    <CloudDownload />
                  </IconButton>
                  {/* {setIsDelete && setSelectedFile && (
                    <IconButton
                      edge="end"
                      aria-label="eliminar"
                      onClick={() => {
                        setIsDelete(true);
                        setSelectedFile(file);
                      }}
                      color="error"
                    >
                      <Delete />
                    </IconButton>
                  )} */}
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        )}
      </Box>
    </Paper>
  );
};

export default FileList;
